<script setup lang="ts">
import type { PropType } from 'vue';

import { ROUTE_NAMES } from '~/constants/routes';
import { isAuction, type SaleItemEntity } from '~/types/sale.type';

// PROPS
const { sale } = defineProps({
    sale: { type: Object as PropType<SaleItemEntity>, required: true },
});

// COMPOSABLES
const { tt } = useTypedI18n();
const { data: authData } = useAuthUtils();
const route = useRoute();
const localePath = useLocalePath();
const { trackNegotiationGoToNegotiation } = useTracking();

// DATA
const isBuyer = computed(() => sale.sellerCompanyId !== authData.value?.user?.companyId);

const label = computed(() => tt(isAuction(sale) || isBuyer.value ? 'negotiation.goToNegotiation' : 'negotiation.showNegotiations'));

const routeTo = computed(() => ({
    name: isAuction(sale) ? ROUTE_NAMES.AUCTION_DETAIL_NEGOTIATION : ROUTE_NAMES.DIRECT_SALE_DETAIL_NEGOTIATION,
    params: route.params,
}));

// METHODS
const onBuyerClick = (): void => {
    trackNegotiationGoToNegotiation('go_negotiation');
};

const onSellerClick = (): void => {
    trackNegotiationGoToNegotiation(isAuction(sale) ? 'go_negotiation' : 'show_negotiation');
};
</script>

<template>
    <NuxtLinkLocale v-if="isBuyer" class="text-center text-xs font-semibold underline md:text-base" :to="routeTo" @click="onBuyerClick">
        {{ label }}
    </NuxtLinkLocale>

    <UButton
        v-else
        size="lg"
        variant="solid"
        :ui="buttonResponsiveSizeUi('lg', 'xl')"
        :label="label"
        block
        :to="localePath(routeTo)"
        @click="onSellerClick"
    />
</template>
